import { Component, inject } from '@angular/core';
import {
  MatDialogRef,
  MatDialogTitle,
  MatDialogContent,
  MatDialogActions,
  MatDialogClose,
} from '@angular/material/dialog';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { FormsModule } from '@angular/forms';
import { MatDivider } from '@angular/material/divider';
import { TranslateModule } from '@ngx-translate/core';
import { MatRadioButton, MatRadioGroup } from '@angular/material/radio';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { Exam } from 'src/app/api/models';
import { ButtonComponent } from 'src/app/shared/components/button/button.component';

interface ExamTemplate {
  name: string;
  value: string;
  assets: string;
}

@Component({
  selector: 'qa-exam-template-dialog',
  templateUrl: './exam-template-dialog.component.html',
  styleUrl: './exam-template-dialog.component.scss',
  imports: [
    MatDialogTitle,
    CdkScrollable,
    MatDialogContent,
    MatRadioGroup,
    FormsModule,
    MatRadioButton,
    MatDivider,
    MatDialogActions,
    MatDialogClose,
    TranslateModule,
    ButtonComponent,
  ],
})
export class ExamTemplateDialogComponent {
  template: ExamTemplate;
  templates: ExamTemplate[] = [
    {
      name: 'Arbeitssicherheit und Gesundheitsschutz',
      value: 'arbeitssicherheit_gesundheitsschutz',
      assets:
        'assets/exam-templates/unterweisung-arbeitssicherheit-und-gesundheitsschutz.json',
    },
    {
      name: 'Brandschutz und Evakuierung',
      value: 'brandschutz_evakuierung',
      assets:
        'assets/exam-templates/unterweisung-brandschutz-und-evakuierung.json',
    },
    {
      name: 'Gefahrstoffunterweisung (GefStoffV)',
      value: 'gefahrstoffunterweisung_gefstoffv',
      assets: 'assets/exam-templates/gefahrstoffunterweisung-(gefstoffv).json',
    },
    {
      name: 'Hygiene und Infektionsschutz',
      value: 'hygiene_infektionsschutz',
      assets:
        'assets/exam-templates/unterweisung-hygiene-und-infektionsschutz.json',
    },
    {
      name: 'Unterweisung im Umweltschutz',
      value: 'unterweisung_umweltschutz',
      assets: 'assets/exam-templates/unterweisung-im-umweltschutz.json',
    },
    {
      name: 'Compliance-Schulung',
      value: 'compliance_schulung',
      assets: 'assets/exam-templates/unterweisung-compliance-schulung.json',
    },
    {
      name: 'Gleichstellung und Antidiskriminierung (AGG)',
      value: 'gleichstellung_antidiskriminierung_agg',
      assets:
        'assets/exam-templates/unterweisung-gleichstellung-und-antidiskriminierung-(agg).json',
    },
    {
      name: 'Erste-Hilfe-Schulung',
      value: 'erste_hilfe_schulung',
      assets: 'assets/exam-templates/unterweisung-erste-hilfe-schulung.json',
    },
  ];

  private httpClient = inject(HttpClient);

  constructor(public dialogRef: MatDialogRef<ExamTemplateDialogComponent>) {}

  async selectTemplate() {
    if (!this.template) return null;
    const templateJson = await firstValueFrom(
      this.httpClient.get<Exam>(this.template.assets)
    );
    delete templateJson.status;
    this.dialogRef.close({ data: templateJson });
  }
}
